<template>
  <div class="anony-box form-check text-center">
    <template v-if="isForced">
      <span class="form-check-label">{{ $t(textForcedAnonymousEvaluation) }}</span>
    </template>
    <template v-else>
      <input
        class="form-check-input"
        id="anonymCheck"
        type="checkbox"
        :value="value"
        @input="$emit('input', $event.target.checked)"
      />
      <label class="form-check-label" for="anonymCheck">{{ $t(text) }}</label>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    text: { type: String, default: 'generic.anonymousEvaluation' },
    textForcedAnonymousEvaluation: { type: String, default: 'generic.forceAnonymousEvaluation' },
    isForced: { type: Boolean, default: false },
  },
  mounted() {
    if (this.isForced) {
      this.$emit('input', true);
    }
  },
};
</script>
